<template>
	<div class="home">
		<header>
			<nav>
				<img src="../assets/images/icons/menu.svg" class="menu-icon" alt="" @click="menu()">
				<ul class="desktop">
					<li><a href="#" v-scroll-to="{ el: '#about-me', offset: -50 }">Sobre mi</a></li>
					<li><a href="#" v-scroll-to="{ el: '#portafolio' }">Portafolio</a></li>
					<li><a href="#" v-scroll-to="{ el: '#testimonies', offset: -200 }">Testimonios</a></li>
					<li><a href="#" v-scroll-to="{ el: '#contact', offset: 90 }">Contacto</a></li>
					<li class="option__nohref">
						<a>Síguenos</a>
						<a class="option__social" href="https://www.instagram.com/llagunoximena/">
							<img src="../assets/images/social/instagram.png" alt="">
						</a>
					</li>
				</ul>

				<ul class="mobile" v-bind:class="{ appear: openMenu, disappear: openMenu === false }">
					<li><a href="#" v-scroll-to="{ el: '#about-me', offset: -50 }">Sobre mi</a></li>
					<li><a href="#" v-scroll-to="{ el: '#portafolio' }">Portafolio</a></li>
					<li><a href="#" v-scroll-to="{ el: '#testimonies', offset: -200 }">Testimonios</a></li>
					<li><a href="#" v-scroll-to="{ el: '#contact', offset: 90 }">Contacto</a></li>
					<li class="option__nohref">
						<a>Síguenos</a>
						<a class="option__social" href="https://www.instagram.com/llagunoximena/">
							<img src="../assets/images/social/instagram.png" alt="">
						</a>
					</li>
				</ul>
			</nav>
		</header>

		<div class="container-fluid">
			<div id="intro">
				<h1 class="hide">Wedding Planner</h1>
				<div class="intro__logo--wrapper">
					<img src="../assets/images/LOGO-ROSA-XIMENA-transparent.png" alt="">
				</div>
			</div>

			<div id="about-me">
				<div class="row">
					<div class="about-me__image">
						<img src="../assets/images/ximena-llaguno.jpg" height="389" width="353" alt="">
					</div>
					<div class="about-me__description">
						<h2>Ximena Llaguno Vidal</h2>
						<p>Soy Egresada de la Universidad Panamericana en la carrera de Administración de Instituciones de Servicio (ESDAI). Al graduarme trabajé en el Club de Banqueros de México y es ahí donde aprendo a hacer bodas y eventos. Hace 12 años decido independizarme y dedicarme a organizar lo que más amo hacer: ¡BODAS! <br><br>

						La razón por la que es un placer hacer mi trabajo, es porque estoy en el momento más importante de la vida de dos personas y el poder acompañarlas en el proceso para que este acontecimiento sea maravilloso es lo que me hace ser mejor persona. <br><br>

						Con cada boda el trato es personalizado, me enfoco en ayudarles a que todo lo que imaginaron lo podamos plasmar en la realidad y que tanto ustedes como sus familias se sientan invitados de honor y dejen en nuestras manos este gran DIA. <br><br>

						Tengo la fortuna de trabajar con los mejores del medio, todos los proveedores con los que hacemos tu boda son los más reconocidos y con los que tendrás la tranquilidad de que son personas profesionales, que aman su trabajo y que harán todo su esfuerzo para superar tus expectativas. Elegirás el equipo que más te convenza. <br><br>

						Con una experiencia de más de 400 bodas, mi compromiso al hacer la tuya, es que sientas en todo momento que tienes a una persona que será tus ojos el día de la boda, ten la seguridad que daré mi 100% para que todo fluya en armonía y para que disfrutes tanto el proceso, como la boda.</p>
					</div>
				</div>
			</div>

			<div id="portafolio">
				<div class="row">
					<div class="col s12 portafolio__header">
						<h2 class="center">Portafolio</h2>
					</div>
					<div class="col s12 portafolio__images">
						<div class="image-box">
							<div @click="showModalVideo()" class="video-wrapper"></div>
							<img class="background-image" src="../assets/videos/poster.png" style="filter: blur(2px)">
							<img @click="showModalVideo()" class="icon-image" src="../assets/images/icons/video.svg" alt="">
						</div>
						<div class="image-box" v-for="(image, index) in images" v-if="index <= 8">
							<img class="background-image" :src="getSrc(image.Foto)" alt="" @click="showModalImage(), url = image.Foto, photograph = image.Fotografo, flowers = image.Flores">
						</div>
					</div>
					<div class="col s12 center">
						<a @click="portafolio()">Ver más</a>
					</div>
				</div>
			</div>

			<div id="testimonies">
				<div class="row">
					<div class="col s12 testimonies__box">
						<carousel
							:per-page="1"
							:autoplay="true"
							:autoplayTimeout="30000"
							:loop="true"
							pagination-active-color="#e24a9b"
							adjustable-height="true"
						>
							<slide>
								<h2>Andrea Marcos Hadjopulos</h2>
								<div class="divider"></div>
								<p>“Te quería nada más agradecer por todo ayer, la verdad me hiciste la boda de mis sueños, y no hubiera cambiado nada de todo el trabajo que tu hiciste, me la pasé padrísimo, y todo mundo se llevó la mejor impresión de México y de nuestra Boda, Gracias a ti, así que mil mil gracias por todo. ... hiciste un sueño en la tierra”</p>
							</slide>
							<slide>
								<h2>Sofia Robles Santamarina</h2>
								<div class="divider"></div>
								<p>"Contratar a Xime como wedding planner es la mejor elección que he hecho después de mi esposo! Ella estuvo apoyándome en cada detalle durante toda la planeación de la boda y el mero día, tanto ella como su personal estuvieron atentos a cada detalle durante todo el evento, permitiendo que yo como novia y mi familia disfrutáramos al máximo! Es una persona decente y comprometida que va a buscar que tengas el mejor evento sin que necesariamente tengas que contratar lo más caro. Tiene excelentes proveedores, igual de profesionales y comprometidos como ella y una organización impecable. La recomiendo ampliamente!"</p>
							</slide>
							<slide>
								<h2>Alessandra García</h2>
								<div class="divider"></div>
								<p>“¡¡¡MUCHÍSIMAS GRACIAS POR TODO!!! Fue la noche más perfecta. Todos los invitados nos han dicho una y otra vez que es la mejor boda en la que han estado y la mejor fiesta! <br> Estamos muy, muy felices. <br>Te voy a extrañar mucho jajaja, casi lloré despidiéndome!</p>
							</slide>
							<slide>
								<h2>Claudia Gutiérrez y Daniel Abarca</h2>
								<div class="divider"></div>
								<p>“Te queremos mandar un mensaje para agradecerte el evento de ayer, estuvo épico, la pasamos bomba, todo estuvo impecable, perfecto, no hubo nada que cambiaríamos. Te queremos mandar un besote. Te amamos, mil gracias por todo”</p>
							</slide>
							<slide>
								<h2>Mónica Robles Santamarina</h2>
								<div class="divider"></div>
								<p>“Cuando empecé a planear mi boda pensé que iba a ser fácil, que podía hacerlo sin ayuda. A las pocas semanas caí en cuenta de la cantidad de cosas que tienes que coordinar, organizar y tener listas antes del día. Fue entonces que decidí contactar a Ximena. <br> No sé qué hubiera hecho sin su ayuda. Ximena me contactó con los mejores proveedores, me dio ideas de decoración, invitaciones, menú; incluso me ayudó a organizar las mesas. <br> Si estás pensando en contratar alguna empresa para que te ayude con la planeación de tu boda, no necesitas buscar más, Ximena y su equipo me demostraron que son gente profesional, cuidadosa de los detalles, y realmente preocupada para que tu boda sea el mejor día de tu vida.”</p>
							</slide>
							<slide>
								<h2>Maite González Peredo</h2>
								<div class="divider"></div>
								<p>“Ximena Llaguno nos vino a alegrar la planeación de nuestra boda después de una muy mala experiencia con otra “wedding planner”. Hoy hay muchas que se cuelgan la medalla de saber organizar bodas, pero sólo Ximena sabe cómo dejar que los novios y la familia disfrute y todo salga a la perfección. La mejor wedding planner y event planner de México.”</p>
							</slide>
							<slide>
								<h2>Beatriz I. Pardo</h2>
								<div class="divider"></div>
								<p>“Como vivimos en España, cuando decidimos celebrar nuestra boda en México, sabíamos que necesitábamos contratar los servicios de un profesional que conociera el mercado de primera mano. Con este propósito, entrevistamos a todos los wedding planners de los que teníamos buena referencia, decantándonos por Ximena porque, además de contar con excelentes referencias y dilatada experiencia en el sector, supo entender perfectamente nuestras necesidades, que no eran las de una boda al uso, y adaptarse completamente a nuestro estilo. <br> Contar con Ximena nos permitió organizar el evento los días en que visitábamos México, asegurarnos de que no faltaba nada y dedicarnos en exclusiva a disfrutar; todo ello con un trato cercano y amable, y una capacidad de adaptación infinita, tanto con nosotros como con todos los invitados de la boda, que quedaron encantados con ella. <br> De vuelta en España, organizamos, por nuestra cuenta, una fiesta mucho más simple en la que pudimos comprobar todo el trabajo que Ximena nos había ahorrado y lo imprescindible que había sido su presencia para poder disfrutar de nuestro día. <br> Contar con Ximena fue, sin duda, la mejor elección que tomamos en la organización de nuestra boda.”</p>
							</slide>
						</carousel>
					</div>
				</div>
			</div>

			<div id="contact">
				<div class="row">
					<div class="col s12">
						<h2 class="center">Contacto</h2>
					</div>
					<div class="col m6 s12 offset-m3">
						<div class="form">
							<div class="input-field col s12">
								<input type="text" v-model="nombre" name="nombre" id="nombre" placeholder="Nombre" required="" autocomplete="off">
							</div>
							<div class="input-field col s12">
								<input type="text" v-model="telefono" name="telefono" id="telefono" placeholder="Teléfono" required="" autocomplete="off">
							</div>
							<div class="input-field col s12">
								<input type="text" v-model="correo" name="correo" id="correo" placeholder="E-mail" required="" autocomplete="off">
							</div>
							<div class="input-field col s12">
								<date-pick v-model="dia" name="dia" id="dia" :inputAttributes="{placeholder: 'Día del evento'}"></date-pick>
							</div>
							<div class="input-field col s12">
								<textarea name="mensaje" v-model="mensaje" id="mensaje" placeholder="Mensaje" required=""></textarea>
							</div>
							<div class="input-field col s12 center">
								<button @click="submit()">Enviar</button>
							</div>
						</div>
					</div>
				</div>
			</div>

			<modal name="image-modal" height="auto" v-if="url !== null">
				<div class="header">
					<div class="icon-wrapper" @click="hideModalImage">
						<img src="../assets/images/icons/close.svg" alt="">
					</div>
				</div>
				<div class="image">
					<img :src="getSrc(url)" alt="">
				</div>
				<div class="info">
					<p><b>Fotógrafo</b>: {{ photograph }}</p>
					<p>Decoración: {{ flowers }}</p>
				</div>
			</modal>

			<modal name="video-modal" height="auto">
				<div class="header">
					<div class="icon-wrapper" @click="hideModalVideo">
						<img src="../assets/images/icons/close.svg" alt="">
					</div>
				</div>
				<div class="video">
					<video controls="" autoplay>
						<source src="../assets/videos/video.mp4" type="video/mp4">
					</video>
				</div>
				<div class="info">
					<p><b>Autor</b>: franciscoeditor@hotmail.com</p>
				</div>
			</modal>

			<footer>
				<div class="row">
					<div class="col s12 m4 left">
						<p>Ximena Llaguno Wedding Planner ®</p>
					</div>
					<div class="col s12 m4 center">
						<a href="https://www.instagram.com/llagunoximena/">
							<img src="../assets/images/social/instagram.png" alt="">
						</a>
					</div>
					<div class="col s12 m4 right">
						<p><a @click="noticeOfPrivacy()">Aviso de privacidad</a></p>
					</div>
				</div>
			</footer>

			<button class="change-language" @click="changeToEnglish">English</button>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import axios from 'axios';
import { Carousel, Slide } from 'vue-carousel';
import VueSweetalert2 from 'vue-sweetalert2';
import VModal from 'vue-js-modal'
import DatePick from 'vue-date-pick';
import 'vue-date-pick/dist/vueDatePick.css';

Vue.use(VueScrollTo, {
	container: "body",
	duration: 500,
	easing: "ease",
	offset: 0,
	force: true,
	cancelable: true,
	onStart: false,
	onDone: false,
	onCancel: false,
	x: false,
	y: true
})
Vue.use(VueSweetalert2)
Vue.use(VModal)

export default {
	name: 'Spanish',
	data () {
		return {
			// Form
			nombre: '',
			telefono: '',
			correo: '',
			dia: '',
			mensaje: '',

			// Images
			images: [],
			url: null,
			photograph: '',
			flowers: '',
			// 
			openMenu: false,
		}
	},
	methods: {
		changeToEnglish () {
			let language = 'english'
			this.$emit('language', 'english')
		},
		// 
		submit () {
			if (this.nombre === '' || this.telefono === '' | this.correo === '' || this.dia === '' || this.mensaje === '') {
				const Toast = this.$swal.mixin({
				  toast: true,
				  position: 'bottom-end',
				  showConfirmButton: false,
				  timer: 3000
				});

				Toast.fire({
				  type: 'error',
				  title: 'Faltan campos por completar'
				})
			} else {
				var formData = new FormData()
				formData.append('name', this.nombre)
				formData.append('phone', this.telefono)
				formData.append('email', this.correo)
				formData.append('date', this.dia)
				formData.append('message', this.mensaje)

				axios.post('http://ximenallaguno.com/mail.php', formData)

				const Toast = this.$swal.mixin({
				  toast: true,
				  position: 'bottom-end',
				  showConfirmButton: false,
				  timer: 3000
				});

				Toast.fire({
				  type: 'success',
				  title: 'Correo Enviado'
				})

				this.nombre = '',
				this.telefono = '',
				this.correo = '',
				this.dia = '',
				this.mensaje = ''
			}
		},

		// 
		getSrc(name) {
	        var images = require.context('../assets/fotografias/', false, /\.jpg$/);
	        return images('./' + name + ".jpg")
	    },
		showModalImage () {
		    this.$modal.show('image-modal');
		},
		hideModalImage () {
			this.$modal.hide('image-modal');
		},
		// 
		showModalVideo () {
		    this.$modal.show('video-modal');
		},
		hideModalVideo () {
			this.$modal.hide('video-modal');
		},
		// 
		menu () {
			if (this.openMenu === false) {
				this.openMenu = true
			} else {
				this.openMenu = false
			}
		},

		portafolio () {
			this.$router.push({name: 'Portafolio'});
		},
		noticeOfPrivacy() {
			this.$router.push({name: 'AvisoPrivacidad'});
		}
	},
	mounted () {
		axios
			.get('static/images.json')
			.then(response => (this.images = response.data))
	},
	components: { Carousel, Slide, DatePick }
};
</script>

<style lang="scss">
$gray: #e6ddcc;
$pink: #e24a9b;
$white: #ffffff;
$black: #000000;

@font-face {
	font-family: 'Montserrat';
	src: url('../assets/font/Montserrat-Regular.ttf');
}

body {
	position: relative;
}

h2 {
	text-transform: uppercase;
	color: $pink;
	font-size: 18px;
	font-weight: bold;
	margin-bottom: 20px;
}

h2, p {
	font-family: 'Montserrat', sans-serif;
}

.swal2-popup {
	box-shadow: 0px 0 10px #000000;
}

.desktop {
	display: flex;
}

.mobile {
	display: none;
}

.appear {
	transform: translateX(0px) translateY(0px);
	-webkit-transition: all .3s ease;
	-moz-transition: all .3s ease;
	-ms-transition: all .3s ease;
	-o-transition: all .3s ease;
	transition: all .3s ease;
}

.disappear {
	transform: translateX(0px) translateY(-500px);
	-webkit-transition: all .3s ease;
	-moz-transition: all .3s ease;
	-ms-transition: all .3s ease;
	-o-transition: all .3s ease;
	transition: all .3s ease;
}

header {
	nav {
		position: fixed;
		top: 0;
		left: 0;
		height: 60px;
		width: 100%;
		background-color: $pink;
		padding: 0px 80px;
		z-index: 3000;
		font-family: 'Montserrat', sans-serif;

		.menu-icon {
			display: none;
		}

		ul {
			display: flex;
			justify-content: space-between;
			align-items: center;
			height: 60px;

			li {
				list-style-type: none;

				a {
					text-transform: uppercase;
					text-decoration: none;
					color: $white;
					font-size: 13px;
					letter-spacing: 0.7px;
				}
			}

			.option__nohref {
				display: flex;
				justify-content: center;
				align-items: center;
				a {
					cursor: default;
				}

				a:hover {
					background-color: transparent;
				}

				.option__social {
					padding: 0px;
					display: flex;
					align-items: center;
					cursor: pointer;
				}
			}
		}
	}
}

.home {
	#intro {
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
		width: 100%;
		margin-top: 60px;
		min-height: calc(100vh - 60px);
		height: auto;
		background-image: url('../assets/fotografias/ramo.jpg');
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;

		.intro__logo--wrapper {
			display: flex;
			justify-content: center;
			align-items: center;
			padding: 15px 0;
    		background: linear-gradient(90deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.8) 30%, rgba(255,255,255,0.8) 60%, rgba(255,255,255,0.1) 100%);
			
			img {
				height: auto;
				width: 50%;
			}
		}
	}

	#about-me {
		position: relative;
		padding: 50px 120px;
		background-color: $gray;
		text-align: center;
		font-family: 'Montserrat', sans-serif;

		.row {
			display: flex;
			align-items: center;

			.about-me__description {
				margin-left: 50px;

				p {
					font-size: 14px;
					text-align: justify;
				}
			}
		}
	}

	#portafolio {
		position: relative;
		padding: 50px 120px;

		a {
			color: $pink;
			cursor: pointer;
			font-family: 'Montserrat', sans-serif;
		}

		.portafolio__images {
			display: flex;
			justify-content: space-between;
			flex-wrap: wrap;
			padding: 0px;

			.image-box {
				position: relative;
				width: 19%;
				padding-top: 19%;
				margin: 0.5%;
				overflow: hidden;

				.background-image, video {
					position: absolute;
					transform: translateX(-50%) translateY(-50%);
					top: 50%;
					left: 50%;
					width: auto;
					max-width: 120%;
					max-height: 120%;
					min-width: 100%;
					min-height: 100%;
					cursor: pointer;
				}

				.icon-image {
				    position: absolute;
				    z-index: 56;
				    height: 70px;
				    transform: translateX(-50%) translateY(-50%);
				    top: 50%;
				    left: 50%;
				    cursor: pointer;
				}

				video {
					max-width: initial;
				}
			}

			.video-wrapper {
			    position: absolute;
			    background: rgba(0, 0, 0, .60);
			    top: 0;
			    bottom: 0;
			    left: 0;
			    right: 0;
			    z-index: 5;
			    cursor: pointer;

			}
		}
	}

	#testimonies {
		position: relative;
		padding: 50px 120px;
		background-color: $gray;

		.testimonies__box {
			border: 3px solid $pink;
			width: calc(100% - 6px);
			padding: 20px 30px;

			h2 {
				margin-bottom: 5px;
			}

			.divider {
				background-color: $pink;
				height: 3px;
				width: 90%;
				margin-bottom: 15px;
			}

			p {
				text-align: justify;
			}
		}
	}

	#contact {
		position: relative;
		padding: 50px 120px;
		min-height: 100vh;
		height: auto;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;

		.form {
			.input-field {
				padding: 0px;
				margin: 5px 0px;

				input, textarea {
					font-family: 'Montserrat', sans-serif;
					background-color: $gray;
					color: $black;
					font-size: 14px;
					margin: 0px;
					border: none;
					padding: 0px 10px;
					width: calc(100% - 20px);
					height: 40px;
				}

				input:focus {
					border: none;
					box-shadow: none;
				}

				textarea {
					width: 100%;
					resize: none;
					padding: 10px;
					height: 100px;
				}

				textarea:focus {
					outline:none;
				}

				#dia {
					width: 100%;

					button {
						background: transparent;
						border: none;
						color: black;
						border-radius: 0px;
						padding: 1em .4em;
						letter-spacing: normal;
					}
				}

				button {
					background-color: $pink;
					border: none;
					color: $white;
					border-radius: 100px;
					padding: 10px 30px;
					text-transform: uppercase;
					font-size: 14px;
					letter-spacing: 1.7px;
					cursor: pointer;
				}

				::placeholder {
						color: #989898;
						opacity: 1;
						font-style: italic;
						font-size: 14px;
				}

				:-ms-input-placeholder {
						color: #989898;
						font-style: italic;
						font-size: 14px;
				}

				::-ms-input-placeholder {
						color: #989898;
						font-style: italic;
						font-size: 14px;
				}
			}
		}
	}

	footer {
		background-color: $pink;
		color: $white;
		padding: 20px 120px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		height: 60px;
		position: absolute;
		bottom: 0px;
		width: 100%;
		z-index: 1;

		.row {
			display: flex;
			align-items: center;
			width: 100%;

			.col {
				padding: 0px;
				
				p {
					text-transform: uppercase;
					font-size: 12px;
					letter-spacing: 0.7px;
					a {
						color: white;
						cursor: pointer;
						text-decoration: none;
					}
				}
			}

			.right {
				text-align: right;
			}
		}
	}

	.change-language {
		position: fixed;
		bottom: 5px;
		right: 30px;
		padding: 10px 20px;
		border-radius: 5px;
		font-family: 'Montserrat', sans-serif;
		border: none;
		color: $white;
		background-color: $pink;
		cursor: pointer;
		box-shadow: 0 0 5px black;
	}
}

.VueCarousel-dot-button {
	background-color: red;
}

.v--modal-overlay {
	z-index: 4000 !important;
	.v--modal-background-click {
		display: flex;
		justify-content: center;
		align-items: center;
	    background: rgba(0, 0, 0, 0.90) !important;

	    .v--modal-box {
    	    top: 0 !important;
		    left: 0 !important;
		    width: 80% !important;
    		height: 90vh !important;
    		background-color: transparent;
    		box-shadow: none !important;
    		color: white;
    		font-size: 14px;

    		.header {
    			height: 8%;
    			text-align: center;
    			display: flex;
    			justify-content: center;
    			align-items: center;
    			background-color: transparent;
    			margin-bottom: 0px;

    			.icon-wrapper {
				    width: 30px;
				    height: 30px;
				    background: rgba(255, 255, 255, 0.16);
				    border-radius: 50px;
				    display: flex;
				    justify-content: center;
				    align-items: center;
				    cursor: pointer;

				    img {
				    	height: 10px;
					}
    			}
    		}

    		.image {
    			position: relative;
    			height: 84% !important;

    			img {
			    	width: auto;
			    	height: auto;
			    	min-height: 100%;
			    	max-height: 100%;
		    	    transform: translateX(-50%) translateY(-50%);
				    left: 50%;
				    top: 50%;
				    position: absolute;
				}
    		}

    		.video {
    			display: flex;
    			justify-content: center;
    			align-items: center;
    			height: 84% !important;
    		}

    		.info {
    			height: 8%;
    			text-align: center;
    		}
		}
	}
}

@media screen and (max-width: 800px) {
	.desktop {
		display: none;
	}

	.mobile {
		display: flex;
	}

	header {
		nav {
			padding: 0px 5% !important;

			.menu-icon {
				display: initial;
				height: 30px;
			    position: absolute;
			    top: 15px;
			    right: 5%;
			}

			.mobile {
				position: absolute;
				width: 100%;
				top: 58px;
				left: 0;
				height: auto;
				flex-direction: column;
				background-color: rgba(226, 74, 155, .85);
				padding-bottom: 20px;
				z-index: -1;

				li {
					height: 80px;
					display: flex;
					align-items: center;
					a {
						font-size: 18px !important;
					}
				}

				.option__nohref {
					flex-direction: column;
					height: auto;
				}
			}
		}
	}

	#intro {
		img {
			width: 80% !important;
		}
	}

	#about-me {
		padding: 50px 5% !important;

		.row {
			flex-direction: column;

			.about-me__image, .about-me__description {
				width: 100% !important;
				margin: 0px !important;

				img {
					width: 90%;
					height: auto !important;
				}
			}
		}
	}

	#portafolio {
		padding: 50px 5% !important;

		.row {
			.portafolio__images {
				margin-bottom: 10px;
				.image-box {
					width: 49% !important;
					padding-top: 49% !important;
				}
			}
		}

		a {
			font-size: 18px;
		}
	}

	#testimonies {
		padding: 50px 5% !important;
	}

	#contact {
		padding: 50px 5% !important;
		padding-bottom: 76px !important;
	}

	footer {
		padding: 20px 5% !important; 
		height: auto !important;

		.row {
			flex-direction: column;

			p {
				text-align: center;
			}
		}
	}

	.v--modal-overlay {
		.v--modal-background-click {
		    .v--modal-box {
	    		.header {
	    			height: 20%;
	    		}

	    		.image {
	    			position: relative;
	    			height: 60% !important;

	    			img {
				    	min-height: auto;
				    	max-width: 100%;
					}
	    		}

	    		.video {
	    			height: 60% !important;
	    			max-width: 100%;

	    			video {
	    				max-width: 100%;
	    			}
	    		}

	    		.info {
	    			height: 20%;
	    		}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/Spanish.vue